import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/website-v2/RemontPodKluczPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/kredyt.css");
